// Renders a doubles/singles entry as clickable member links.
// Each half of "A / B" is linked to its profile when profile_id is present.
// Falls back to plain text for manual entries with no profile.
import React from 'react';
import MemberLink from './MemberLink';

export default function EntryDisplay({ entry, className = '' }) {
  if (!entry) return <span className={className}>TBD</span>;
  const p1 = entry.player1_name;
  const p2 = entry.player2_name;
  const id1 = entry.player1_profile_id;
  const id2 = entry.player2_profile_id;
  // Team-name preference (RR Update 1). When admin has set an explicit
  // team name, show it as the primary label. If we also have player
  // names, keep them as a small subtitle so member links remain
  // reachable (won't break existing tap-through UX).
  if (entry.team_name) {
    if (p1 || p2) {
      return (
        <span className={className}>
          <span className="font-medium">{entry.team_name}</span>
          <span className="text-[10px] text-[#9aa39d] ml-1">
            (<MemberLink profileId={id1} name={p1} />
            {p2 && <><span> / </span><MemberLink profileId={id2} name={p2} /></>})
          </span>
        </span>
      );
    }
    return <span className={className}>{entry.team_name}</span>;
  }
  if (!p1 && !p2) return <span className={className}>{entry.display_name || 'Player'}</span>;
  if (!p2) return <MemberLink profileId={id1} name={p1} className={className} />;
  return (
    <span className={className}>
      <MemberLink profileId={id1} name={p1} />
      <span className="text-[#9aa39d]"> / </span>
      <MemberLink profileId={id2} name={p2} />
    </span>
  );
}
